/**
 * Tekstovi za hladni mejl (copy-paste u Gmail).
 * Vraća predmet i telo za 3 varijante: promo, cta (kratko), short (tizer).
 *
 * URL-ovi se generišu iz REACT_APP_PUBLIC_URL ako postoji,
 * inače iz window.location.origin (sa fallbackom na https://spintasker.com).
 */
export function getPublicSiteBase() {
  const fromEnv =
    typeof process !== 'undefined' && process?.env?.REACT_APP_PUBLIC_URL
      ? String(process.env.REACT_APP_PUBLIC_URL).replace(/\/$/, '')
      : '';
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return 'https://spintasker.com';
}

const BUSINESS_EMAIL = 'info@spintasker.com';

export function buildOutreachTemplates({ contactEmail = '' } = {}) {
  const base = getPublicSiteBase();
  const homeUrl = base;
  const emailParam =
    contactEmail && String(contactEmail).includes('@')
      ? `?email=${encodeURIComponent(String(contactEmail).trim().toLowerCase())}`
      : '';
  const tutorialsUrl = `${base}/tutorials${emailParam}`;
  const registerUrl = `${base}/auth?role=company&type=register`;

  const signature = [
    '',
    'Srdačan pozdrav,',
    'Tim SpinTasker',
    BUSINESS_EMAIL,
    homeUrl
  ].join('\n');

  const promo = {
    subject: 'SpinTasker — alat za servisere i majstore na terenu',
    body: [
      'Poštovani,',
      '',
      'obraćamo Vam se kratko, sa idejom da Vam predstavimo SpinTasker —',
      'poslovni alat za servisere i firme koje rade na terenu.',
      '',
      'Šta dobijate na jednom mestu:',
      '• poslovi, klijenti i kalendar sa zakazivanjem',
      '• evidencija radnika, partnera i rezervnih delova',
      '• jasan pregled statusa i istorije, bez papirologije',
      '',
      'Bez obaveze, samo da pogledate kako izgleda u praksi:',
      `• Video tutorijali: ${tutorialsUrl}`,
      `• Više o aplikaciji i paketima: ${homeUrl}`,
      '',
      'Ako Vam se učini korisno, rado ćemo Vam odgovoriti na pitanja',
      'ili dogovoriti kratki demo.',
      '',
      'Hvala na vremenu.',
      signature
    ].join('\n')
  };

  const cta = {
    subject: 'Kratak prikaz SpinTasker-a (2 minuta)',
    body: [
      'Poštovani,',
      '',
      'za sve koji vode servis ili izlaze na teren, SpinTasker ujedinjuje',
      'poslove, klijente, kalendar, radnike i rezervne delove na jednom mestu.',
      '',
      'Najkraći način da vidite o čemu se radi su naši video tutorijali:',
      tutorialsUrl,
      '',
      `Više informacija i opcija na: ${homeUrl}`,
      '',
      'Ako Vam nešto nije jasno ili želite kratak demo, slobodno odgovorite',
      'na ovaj mejl.',
      signature
    ].join('\n')
  };

  const short = {
    subject: 'Pogled na SpinTasker — bez obaveze',
    body: [
      'Poštovani,',
      '',
      'ako vodite servis ili rad na terenu, SpinTasker bi mogao da Vam',
      'uštedi vreme oko zakazivanja, klijenata i evidencije poslova.',
      '',
      'Najlakše je videti kroz par kratkih videa:',
      tutorialsUrl,
      '',
      `Za više detalja: ${homeUrl}`,
      '',
      `Ako želite, javite se na ${BUSINESS_EMAIL} — odgovaramo brzo.`,
      signature
    ].join('\n')
  };

  return {
    promo,
    cta,
    short,
    tutorialsUrl,
    registerUrl,
    homeUrl,
    businessEmail: BUSINESS_EMAIL
  };
}
